import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filter',
	pure: false,
	standalone: true
})
export class FilterPipe implements PipeTransform {
	transform<T>(items: T[] | null | undefined, predicate: (value: T, index: number) => boolean): T[] {
		if (!items || !Array.isArray(items)) {
			return [];
		}
		return items.filter(predicate);
	}
}
